// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tablePanel td[data-v-71ab8ce2]{\r\n  height: 14px\n}\n#tblMain[data-v-71ab8ce2]{\r\n  width: 1000px;\r\n  border: 1px solid red;\n}\n.tblMainTR[data-v-71ab8ce2]{\r\n\r\n  border-top: 1px solid red;\r\n  border-bottom: 1px solid red;\n}\n.btn[data-v-71ab8ce2]{\r\n  color: white !important;\r\n  margin: 5px;\r\n  /*width: 40px;*/\n}\r\n", ""]);
// Exports
module.exports = exports;
